import { render, staticRenderFns } from "./NotificationResults.vue?vue&type=template&id=0bed2526&"
import script from "./NotificationResults.vue?vue&type=script&lang=js&"
export * from "./NotificationResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports